import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import GridViewIcon from '@mui/icons-material/GridView'
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import { routeFrontOfficeManageUserTeam } from '@/lib/routes/front/common/routeFrontOfficeManageUserTeam'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

// Pages de GESTION reservees aux MANAGERS du groupement / de la chaine (role de route
// ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_MANAGER, pose par l'API pour
// ROLE_GROUPEMENT_MANAGER / ROLE_CHAIN_MANAGER seulement) : un delegue ou un manager de zone
// n'a que les pages communes (getFrontOfficeGroupGroupementChainListRoutesAllUser).
const routeGroupementActivity = [
  {
    // HORS menu : le contenu du Rapport d'activite est affiche par le « Tableau de
    // bord » des managers (pages/frontoffice/group/home). La page directe reste
    // accessible (deep links).
    route: 'GroupementActivity',
    text: "Rapport d'activité",
    t: 'routes.frontoffice.groupement.activity',
    icon: QueryStatsIcon,
    href: '/industryoffice/groupement-chain/activity',
    menuHeader: false,
    position: 50,
  },
  {
    // Souscription de services : item de NIVEAU 1 (a plat, hors groupe), dernier
    // du bloc de tete (apres Rapport d'activite et Cartes des pharmacies).
    route: 'GroupementServiceActivation',
    text: 'Activation de services',
    t: 'routes.frontoffice.groupement.serviceActivation',
    icon: AutoAwesomeOutlinedIcon,
    href: '/industryoffice/groupement-chain/nouveaux-services',
    menuHeader: true,
    menuFlat: true,
    position: 300,
  },
  {
    route: 'GroupementPartners',
    text: 'Laboratoires partenaires',
    t: 'routes.frontoffice.groupement.partners',
    icon: HandshakeOutlinedIcon,
    href: '/industryoffice/groupement-chain/partners',
    menuHeader: true,
    position: 55,
  },
  {
    // Listes d'adherents (import CIP) : reutilisees par l'outil de creation de spot Sound
    // pour cibler une partie du groupement (champ companyListContactId). Meme page que
    // « Mes listes clients » de l'espace industry ; l'API scope les listes sur la company.
    route: 'MyListTargets',
    text: "Mes listes d'adhérents",
    t: 'routes.frontoffice.groupement.myListTargets',
    icon: FormatListBulletedIcon,
    href: '/industryoffice/group/my-list-targets',
    menuHeader: true,
    position: 110,
  },
  {
    // Gestion des zones (decoupage du parc) : gestion, donc managers seulement.
    route: 'Zone',
    text: 'Zones',
    t: 'routes.frontoffice.groupement.zone',
    icon: GridViewIcon,
    href: '/industryoffice/group/zone-list',
    menuHeader: true,
    position: 200,
  },
  {
    route: 'ZoneEdit',
    text: 'Zones',
    t: 'routes.frontoffice.groupement.zone',
    icon: GridViewIcon,
    href: '/industryoffice/group/zone/edit/[zoneId]',
    menuHeader: false,
  },
]

export const getFrontOfficeSchoolGroupementChainListRoutesManager = [
  ...routeGroupementActivity,
  ...routeFrontOfficeManageUserTeam,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_MANAGER],
}))

export default getFrontOfficeSchoolGroupementChainListRoutesManager
